<div
  class="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2"
>
  <div class="paginator-container d-flex align-items-center gap-1 gap-md-2">
    <div class="d-flex gap-2 align-items-center">
      <label for="entriesPerPage">Entries per page:</label>
      <ng-select
        [items]="entriesOptions"
        [(ngModel)]="selectedEntries"
        (change)="onEntriesChange($event)"
        [clearable]="false"
        [searchable]="false"
      >
      </ng-select>
    </div>
    <label for="entriesPerPage" class="me-2">
      Collection Size: {{ collectionSize }}
    </label>
  </div>

  <ngb-pagination
    [collectionSize]="collectionSize"
    [(page)]="page"
    [pageSize]="selectedEntries"
    [maxSize]="5"
    [boundaryLinks]="true"
    [ellipses]="false"
    (pageChange)="onPageChange($event)"
  ></ngb-pagination>
</div>
